<span #hiddenText>{{ text }}</span>
<input type="text" readonly [value]="text" #txt (click)="clicked(txt)" [style.width.px]="width">
<button (click)="copy()" type="button" [nbTooltip]="'copytoclipboard' | translate" nbTooltipStatus="success">
  <nb-icon icon="clipboard-outline"></nb-icon>
</button>
@if (link) {
  <button type="button">
    <a [href]="text" target="_blank">
      <nb-icon icon="external-link-outline"></nb-icon>
    </a>
  </button>
}
